import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useAppSelector } from "../ReduxToolkit/Hooks";
import { innerAuthRoutes } from "./AuthPaths";
import PrivateRouters from "./PrivateRouters";
import RedirectRoute from "./RedirectRoute";
import { routes } from "./Route";
import Error404 from "../Components/Pages/Others/ErrorPage/Error404";
import { lazy, Suspense } from "react";
import Loader from "../Layout/Loader";

const Auth = lazy(() => import("../Auth/Auth"));
const Layout = lazy(() => import("../Layout/Layout"));

const Routers = () => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  return (
    <BrowserRouter>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path={`${process.env.PUBLIC_URL}` || `/`} element={<Navigate to={isAuthenticated ? `${process.env.PUBLIC_URL}/dashboard/default` : `${process.env.PUBLIC_URL}/login`} />} />
          {routes.map((item, index) => (
            <Route element={<Layout />} key={index}>
              <Route path={item.path} element={<RedirectRoute>{item.element}</RedirectRoute>} />
            </Route>
          ))}
          {innerAuthRoutes.map((item, index) => (
            <Route key={index} path={item.path} element={<RedirectRoute>{item.element}</RedirectRoute>} />
          ))}
          <Route path={`${process.env.PUBLIC_URL}/login`} element={<PrivateRouters><Auth /></PrivateRouters>}/>
          <Route path={'*'} element={<Error404/>} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default Routers;
